module.exports = __webpack_public_path__ + "img/login_blanco.8be3d57a.svg";